import Swiper, { Navigation } from "swiper";

const QuoteSlider = () => {
	const quoteSlider = document.getElementsByClassName("quote-slider");
	Swiper.use([Navigation]);

	const initSlider = (section) => {
		const swiperContainer = section.querySelector(".swiper-container");

		/* eslint-disable no-unused-vars */
		const swiperInstance = new Swiper(swiperContainer, {
			effect: "fade",
			spaceBetween: 16,
			centerInsufficientSlides: true,
			loop: true,
			speed: 1000,
			slidesPerView: 1,
			autoplay: {
				delay: 8000,
				disableOnInteraction: false,
			},

			// pagination dots
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},

			on: {
				/* eslint-disable */
				init: function () {
					const swiper = swiperContainer.swiper;

					if (swiper.slides.length > 3) {
						// swiper activated
						swiperContainer.classList.remove("swiper-disabled");
					} else if (swiper.slides.length == 3) {
						// swiper deactivated
						swiperContainer.classList.add("swiper-disabled");
					}
				},

				/* eslint-enable */
			},
		});
		/* eslint-enable no-unused-vars */
	};

	if (quoteSlider[0]) {
		Array.from(quoteSlider).forEach((section) => initSlider(section));
	}
};

export default QuoteSlider;
